import { render, staticRenderFns } from "./TitleCommentControl.vue?vue&type=template&id=4c61d75e&scoped=true"
import script from "./TitleCommentControl.vue?vue&type=script&lang=js"
export * from "./TitleCommentControl.vue?vue&type=script&lang=js"
import style0 from "./TitleCommentControl.vue?vue&type=style&index=0&id=4c61d75e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c61d75e",
  null
  
)

export default component.exports